"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
/**
 * @deprecated reconsider the use-case for this class
 */
class Panel extends fmko_ts_common_1.Widget {
    constructor() {
        super();
        this.element = document.createElement("div");
    }
    clearHTMLChildren() {
        const element = this.element;
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
    }
}
exports.default = Panel;
//# sourceMappingURL=Panel.js.map